import { VOLUME_PRICING_SHADE } from "@faire/deprecated-retailer-visitor-shared/consts/colors";
import { Core } from "@faire/design-tokens";
import { Check } from "@faire/slate/icons/Check";
import { cn } from "@faire/web/tools/cn";
import React from "react";

// eslint-disable-next-line import/no-unassigned-import
import "./progressDotAnimation.tw.css";

export interface IProgressDotProps {
  currentTierPercentage: string;
  shouldAnimate?: boolean;
  isSmall?: boolean;
}

export const ProgressDot: React.FC<IProgressDotProps> = ({
  currentTierPercentage,
  shouldAnimate,
  isSmall,
}) => {
  return (
    <div
      className={cn(
        "border-core-border-inverse absolute -top-2 left-0 flex transform-[translateX(-50%)] items-center justify-center rounded-full border-2",
        shouldAnimate ? "animate-scale-dot" : undefined,
        isSmall ? "h-6 w-6" : "h-7 w-7"
      )}
      style={{
        backgroundColor: VOLUME_PRICING_SHADE,
        left: currentTierPercentage,
      }}
    >
      <Check
        color={Core.icon.inverse}
        strokeWidth={isSmall ? "3px" : "2px"}
        fontSize={isSmall ? "8px" : "12px"}
      />
    </div>
  );
};
